import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HubstaffMeDTO } from '../core/models/hubstaff-me.model';
import { IconTypes } from '../shared/icon/icon.component';
import { BtnClickEvent, ButtonComponent } from '../shared/button/button.component';

@Component({
  selector: 'app-hubstaff-account',
  templateUrl: './hubstaff-account.component.html',
  imports: [ButtonComponent],
})
export class HubstaffAccountComponent {
  @Input() me: HubstaffMeDTO | undefined;
  @Output() removeHandler = new EventEmitter();
  @Output() cancelHandler = new EventEmitter();

  get IconTypes() {
    return IconTypes;
  }
  async removeToken(event: BtnClickEvent): Promise<void> {
    this.removeHandler.emit(event);
  }

  cancelRedirect(): void {
    this.cancelHandler.emit();
  }
}
